<div class="app-page-container">

  <div *ngIf="loading" class="d-flex app-text-success justify-content-center align-items-center">
    <span class="spinner-border spinner-border-sm mr-1"></span>
    Loading Bug Reports...
  </div>

  <!-- BUG REPORT LIST -->
  <section *ngIf="!loading">
    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h1 class="mb-3 mr-3" style="line-height: 1">
        Bug Reports
      </h1>
    </div>

    <!-- SEARCH -->
    <form [formGroup]="searchForm" class="input-group mb-3">
      <div class="input-group-prepend">
        <button class="btn app-btn-success" style="z-index:0" type="submit" (click)="onSearch(searchForm.value)">
          Search
        </button>
      </div>
      <input
        class="form-control"
        formControlName="search"
        type="text"
        [maxlength]="36"
        required
      />
      <div class="input-group-append">
        <button *ngIf="searchActive()" class="btn app-btn-neutral" type="button" (click)="onClearSearch()">
          Clear
        </button>
      </div>
    </form>
    <button class="btn btn-sm app-btn-neutral mb-2" (click)="toggleResolvedView()">
      <ng-container *ngIf="!showResolved">
        Show resolved bug reports
      </ng-container>
      <ng-container *ngIf="showResolved">
        Hide resolved bug reports
      </ng-container>
    </button>
    <div *ngIf="!filteredBugReports.length">
      No bug reports to display
    </div>
    <article 
      *ngFor="let bugReport of filteredBugReports; let i = index"
      id="bugReportAccordion"
      class="accordion card mb-3"
    >
      <div class="card-header app-text-white app-bg-dark d-flex justify-content-start">
        <div class="d-flex align-items-center justify-content-between w-100">
          <span>{{ bugReport.form.reporterName + ": " + ((bugReport.form.summary || bugReport.form.description) | truncate:50) }}</span>
          <app-pill-box [pills]="bugReport.tags | arrayToPills" [editable]="false"></app-pill-box>
        </div>
      </div>
      <div class="card-body d-flex align-items-start justify-content-between">
        <div>
          <p class="card-text"><strong>ID:</strong> {{ bugReport.id }}</p>
          <p class="card-text text-break"><strong>Reporter Name:</strong> {{ bugReport.form.reporterName }}</p>
          <p class="card-text text-break"><strong>Email:</strong> {{ bugReport.form.reporterEmail }}</p>
          <p class="card-text text-break"><strong>URL: </strong><a [href]="bugReport.form.url">{{ bugReport.form.url }}</a></p>
          <p *ngIf="migrateBugReportDealsEnabled" class="card-text text-break"><strong>Debug URL: </strong><a [href]="useDebugEnv(bugReport.form.url)">{{ useDebugEnv(bugReport.form.url) }}</a></p>
          <p class="card-text text-break"><strong>Report Date: </strong>{{ bugReport.form.reportDate }}</p>
          <p class="card-text text-break"><strong>Description</strong><br>
            {{ bugReport.form.description }}
          </p>
          <button
            class="btn btn-sm app-btn-neutral mr-2"
            type="button"
            data-toggle="collapse"
            [attr.data-target]="'#collapse-deal-' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse-deal-' + i"
          >
            View Deal
          </button>
          <button
            class="btn btn-sm app-btn-neutral mr-2"
            type="button"
            data-toggle="collapse"
            [attr.data-target]="'#collapse-vehicle-' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse-vehicle-' + i"
          >
            View Vehicle
          </button>
          <button
            *ngIf="bugReport.attachments?.length"
            class="btn btn-sm app-btn-neutral"
            type="button"
            data-toggle="collapse"
            [attr.data-target]="'#collapse-attachments-' + i"
            aria-expanded="true"
            [attr.aria-controls]="'collapse-attachments-' + i"
          >
            View Attachments
          </button>
        </div>
        <div class="btn-group-vertical ml-3">
          <button class="btn btn-sm app-btn-neutral download-button mb-1" type="button" (click)="downloadJson(bugReport, 'deal')">
            <mat-icon>download</mat-icon>
            deal.json
          </button>
          <button class="btn btn-sm app-btn-neutral download-button mb-1" type="button" (click)="downloadJson(bugReport, 'vehicle')">
            <mat-icon>download</mat-icon>
            vehicle.json
          </button>
          <button *ngIf="!showResolved" class="btn btn-sm app-btn-neutral" type="button" (click)="resolve(bugReport.id)">
            Mark as resolved
          </button>
          <button *ngIf="showResolved" class="btn btn-sm app-btn-neutral" type="button" (click)="unresolve(bugReport.id)">
            Mark as unresolved
          </button>
        </div>
      </div>
      <div
        [id]="'collapse-deal-' + i"
        class="collapse json-display"
        [attr.aria-labelledby]="'heading-deal-' + i"
        data-parent="#bugReportAccordion"
      >
        <ngx-json-viewer [json]="bugReport.deal" [expanded]="false"></ngx-json-viewer>
      </div>
      <div
        [id]="'collapse-vehicle-' + i"
        class="collapse json-display"
        [attr.aria-labelledby]="'heading-vehicle-' + i"
        data-parent="#bugReportAccordion"
      >
        <ngx-json-viewer [json]="bugReport.vehicle" [expanded]="false"></ngx-json-viewer>
      </div>
      <div
        [id]="'collapse-attachments-' + i"
        class="collapse json-display"
        [attr.aria-labelledby]="'heading-attachments-' + i"
        data-parent="#bugReportAccordion"
      >
        <mat-table
          class="attachments-table"
          [dataSource]="bugReport.attachments"
          matSortActive="name"
          matSortDirection="asc"
          role="treegrid"
          matSort
        >
          <ng-container matColumnDef="preview">
            <mat-header-cell *matHeaderCellDef class="preview-cell">Preview</mat-header-cell>
            <mat-cell *matCellDef="let element" class="preview-cell">
              <img *ngIf="isImageAttachment(element); else fileIcon"
                   class="attachment-thumbnail"
                   [src]="element.downloadUrl"
                   [alt]="element.name"
                   loading="lazy">
              <ng-template #fileIcon>
                <mat-icon class="attachment-icon">{{ attachmentIcon(element) }}</mat-icon>
              </ng-template>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
            <mat-cell *matCellDef="let element">
              <div class="text-cell">{{ element.name }}</div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="size">
            <mat-header-cell *matHeaderCellDef class="cell-width-15" mat-sort-header>Size</mat-header-cell>
            <mat-cell *matCellDef="let element" class="cell-width-15">
              <div class="text-cell">
                {{ element.size }}
              </div>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row class="clickable-row" *matRowDef="let row; columns: displayedColumns;" (click)="downloadAttachment(row)"></mat-row>
        </mat-table>
      </div>
    </article>
  </section>

</div>
